import * as React from 'react';
export var useInputPin = _ref => {
  var {
    initialValue,
    length,
    autoFocus,
    onChange,
    onComplete
  } = _ref;
  var itemsRef = React.useRef([]);
  var [values, setValues] = React.useState(Array(length).fill('').map((_, i) => initialValue.toString()[i] || ''));
  React.useEffect(() => {
    itemsRef.current = itemsRef.current.slice(0, length);
  }, [length]);
  React.useEffect(() => {
    if (autoFocus && length) itemsRef.current[0].focus();
  }, [autoFocus]);

  var onBackspace = index => {
    if (index > 0) {
      itemsRef.current[index - 1].focus();
    }
  };

  var changeFocus = (direction, index) => {
    if (direction === 'left' && index > 0) {
      itemsRef.current[index - 1].focus();
    } else if (direction === 'right' && index < length - 1) {
      itemsRef.current[index + 1].focus();
    }
  };

  var onPaste = value => {
    if (value.length !== length) {
      return;
    }

    itemsRef.current.forEach((el, index) => el.update(value[index], true));
  };

  var onItemChange = (value, isPasting, index) => {
    var currentIndex = index;
    values[index] = value;
    setValues([...values]); // Set focus on next

    if (value.length === 1 && index < length - 1) {
      currentIndex += 1;
      itemsRef.current[currentIndex].focus();
    }

    var pin = values.join('');

    if (!isPasting) {
      onChange === null || onChange === void 0 ? void 0 : onChange(pin);
    }

    if (pin.length === length) {
      // for pasting, trigger onComplete only when the last input triggers onChange
      if (isPasting && index < length - 1) {
        return null;
      }

      onComplete === null || onComplete === void 0 ? void 0 : onComplete(pin, currentIndex);
    }
  };

  return {
    itemsRef,
    values,
    onItemChange,
    onBackspace,
    changeFocus,
    onPaste
  };
};
//# sourceMappingURL=useInputPin.js.map